<template>
  <div class="animated fadeIn">
    <b-modal centered header-class="notification__modal__header" :visible="hasRestrictions" ok-variant="#277053"
      id="notificationModal" title="ATENÇÃO" ok-only>
      <p>Checar anotações</p>
    </b-modal>
    <RestrictionAlertVue v-if="hasRestrictions" :hasRestrictions="hasRestrictions" />

    <div class="row">
      <div class="col-md-12">
        <div class="card" style="background-color: #fbfbfb;">
          <div class="close-card pb-2">
            <small class="cursor-pointer" @click="onClose">Fechar <i class="far fa-times-circle"></i></small>
          </div>
          <div class="card-block pt-4">
            <!-- HEADER -->
            <input type="hidden" ref="myCopy" id="myCopy" name="myCopy" value="">
            <div class="form-group row">
              <div class="d-flex align-items-center mx-1">
                <b-avatar
                  :text="objSelected && objSelected.pessoa ? getInitialName(objSelected.pessoa.nomeAssociado) : ''"
                  :class="hasRestrictions ? 'danger-border' : ''" size="5rem" style="float: left;"></b-avatar>
              </div>
              <div class="col-md-5">
                <div class="cursor-pointer" @click="onCopyName">
                  <strong style="font-size: 23px;">{{ objSelected ? objSelected.pessoa.nomeAssociado : '' }}</strong>
                  <small><i class="fas fa-clone" v-b-tooltip.hover title="Clique para copiar"></i></small>
                </div>
                <span class="input-group w-sm-50">
                  <b-form-input v-model="form.prinome.value" :placeholder="$lang.Common.prinamePlaceholder" />
                </span>
                <div class="cursor-pointer" @click="onCopyDocument">
                  {{ objSelected ? getTipoPessoa(objSelected.pessoa.document) == 'PF' ? 'CPF' : 'CNPJ' : '' }}: {{ objSelected
                    ? objSelected.pessoa.document : '' }} <small><i class="fas fa-clone" v-b-tooltip.hover
                      title="Clique para copiar"></i></small>
                </div>
                <div class="cursor-pointer" @click="onCopyNumSisbr">
                  Número Sisbr: {{ objSelected ? objSelected.numSisbr : '' }} <small><i class="fas fa-clone"
                      v-b-tooltip.hover title="Clique para copiar"></i></small>
                </div>
                <div v-if="objSelected && objSelected.pessoa.tipoPessoa == 'PJ'">
                  Data de Abertura: &nbsp;{{ objSelected && objSelected.pessoa.dataNascimento ?
                    moment(objSelected.pessoa.dataNascimento.substring(0, 19)).format('DD/MM/YYYY') : '' }}
                </div>
                <div v-else>
                  Data de Nascimento: &nbsp;{{ objSelected && objSelected.pessoa.dataNascimento ?
                    moment(objSelected.pessoa.dataNascimento.substring(0, 19)).format('DD/MM/YYYY') : '' }}
                </div>
              </div>
              <div class="col-md-4 pt-2">
                <div>
                  <strong>PA:</strong>&nbsp;{{ objSelected && objSelected.pa ? objSelected.pa.numero + ' - ' +
                    objSelected.pa.descricao : '' }}
                </div>
                <div><i class="far fa-calendar-check"></i> Início do Relacionamento:&nbsp;<strong>{{ objSelected &&
                  objSelected.inicioRelacionamento ? moment(objSelected.inicioRelacionamento.substring(0,
                    19)).format('DD/MM/YYYY') : '' }}</strong></div>
                <div><i class="fas fa-file-contract"></i> Última Renovação:&nbsp;<strong>{{ objSelected &&
                  objSelected.ultimaRenovacao ? moment(objSelected.ultimaRenovacao.substring(0,
                    19)).format('DD/MM/YYYY') : '' }}</strong></div>
                <div><i class="fas fa-users"></i> Clusterização:</div>
                <span class="input-group">
                  <b-form-select v-model="form.clusterizacaoId.value" :options="form.clusterizacaoId.options">
                    <template slot="first">
                      <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                    </template>
                  </b-form-select>
                </span>
              </div>
              <div class="col-md-2 pt-2">
                <div><i class="fas fa-user"></i> <strong>Tipo Pessoa:</strong>&nbsp;{{ objSelected ?
                  objSelected.pessoa.tipoPessoa : '' }}</div>
                <div><i class="fas fa-exclamation-circle"></i> <strong>Possíveis Pendências:</strong>
                  <div class="checkboxFilds ml-4">
                    <b-form-group class="mt-1 mb-0">
                      <b-form-checkbox id="checkboxProtestado" v-model="form.pendencias.notificado.value">
                        Protestado
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox id="checkboxAjuizado" v-model="form.pendencias.ajuizado.value">
                        Ajuizado
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group>
                      <b-form-checkbox id="checkboxCobranca" :disabled="true" v-model="form.pendencias.cobranca.value">
                        Cobrança
                      </b-form-checkbox>
                      <b-form-checkbox id="checkboxAbsoluta" :disabled="true" v-model="form.pendencias.impeditivaAbsoluta.value">
                        Impeditiva Absoluta
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="form-group row">
              <div class="col-md-6">
                <div class="card">
                  <div class="card-block">
                    <b-avatar class="mr-3 mt-2" style="float: left;">
                      <i class="fas fa-user-tie" style="font-size: 18px"></i>
                    </b-avatar>
                    <div>
                      <strong>Gerente SisBR:<br></strong>{{ objSelected && objSelected.gerenteSisBR ?
                        objSelected.gerenteSisBR.pessoa.nome : 'NÃO INFORMADO' }}
                    </div>

                    <div align="center"
                      v-if="objSelected && objSelected.historicoGerenteSisbr && objSelected.historicoGerenteSisbr.length > 0">
                      <b-button v-b-toggle.historicoGerenteSisbrAlteracao class="mt-1">Mostrar Alterações</b-button>
                      <b-collapse id="historicoGerenteSisbrAlteracao" class="pt-3">
                        <div>
                          <tables ref="tableGrid" :showHeader="false" :columns="['DATA', 'NOME GERENTE']"
                            :showPaging="false" :showTipFooter="false">
                            <tr v-for="(alt, index) in objSelected ? objSelected.historicoGerenteSisbr : []"
                              :key="index + 'PA'">
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1"
                                :value="alt.dataInicio ? formatDateTimeForms(alt.dataInicio) : ''" />
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1"
                                :value="alt.funcionario" />
                            </tr>
                          </tables>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block">
                    <!-- <b-avatar
                      class="mr-3 mt-4"
                      style="float: left; display: inline-block;"
                    >
                      <i class="fas fa-user-tie" style="font-size: 18px"></i>
                    </b-avatar>
                    <div><label><strong>Gerente Relacionamento:</strong></label></div>
                    <div class="mb-2">
                      <v-select
                        v-model="form.gerenteRelacionamento.value"
                        :options="form.gerenteRelacionamento.options"
                        label="nome"
                        disabled>
                        <template v-slot:no-options>Nenhum funcionário encontrado.</template>
                      </v-select>
                    </div> -->
                    <b-avatar class="mr-3 mt-2" style="float: left;">
                      <i class="fas fa-user-tie" style="font-size: 18px"></i>
                    </b-avatar>
                    <div>
                      <strong>{{ $lang.RelationchipManager.Label }}:<br></strong>
                        {{ objSelected && objSelected.gerenteRelacionamento ? objSelected.gerenteRelacionamento.pessoa.nome : 'NÃO INFORMADO'}}
                    </div>

                    <div align="center"
                      v-if="objSelected && objSelected.historicoGerenteRelacionamento && objSelected.historicoGerenteRelacionamento.length > 0">
                      <b-button v-b-toggle.historicoGerenteRelacionamentoAlteracao class="mt-1">Mostrar
                        Alterações</b-button>
                      <b-collapse id="historicoGerenteRelacionamentoAlteracao" class="pt-3">
                        <div>
                          <tables ref="tableGrid" :showHeader="false"
                            :columns="['DATA DA ALTERAÇÃO', 'RESPONSÁVEL', 'NOME GERENTE']" :showPaging="false"
                            :showTipFooter="false">
                            <tr v-for="(alt, index) in objSelected ? objSelected.historicoGerenteRelacionamento : []"
                              :key="index + 'PA'">
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1"
                                :value="alt.dataInicio ? formatDateTimeForms(alt.dataInicio) : ''" />
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1"
                                :value="alt.responsavel" />
                              <TableColumn :style="'font-size: 12px'" :IsText="true" :status="1"
                                :value="alt.funcionario" />
                            </tr>
                          </tables>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block">
                    <div class="form-group row">
                      <div class="col-md-10">
                        <h5><strong><i class="fas fa-map-marker-alt"></i> Logradouro</strong>
                        </h5>
                      </div>
                      <div class="col-md-2">
                        <a v-if="!isBusyLogradouro" href="javascript:void(0);" @click="toggleBusyLogradouro"><i
                            class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover
                            :title="'Minimizar Dados'"></i></a>
                        <a v-else href="javascript:void(0);" @click="toggleBusyLogradouro"><i class="fas fa-eye"
                            style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i></a>
                      </div>
                    </div>
                    <div v-if="!isBusyLogradouro">
                      <div v-if="address && address.length > 0">
                        <b-tabs content-class="mt-3" pills card vertical>
                          <b-tab v-for="(obj, index) in address" :key="index" :title="(index + 1).toString()">
                            <div class="form-group row">
                              <div class="col-md-12">
                                <label><strong>Endereço</strong></label>
                                <div class="input-group">{{ obj.logradouro }}</div>
                              </div>
                            </div>
                            <div class="form-group row pt-2">
                              <div class="col-md-6">
                                <label><strong>Complemento</strong></label>
                                <div class="input-group">{{ obj.complemento }}</div>
                              </div>
                              <div class="col-md-6">
                                <label><strong>Número</strong></label>
                                <div class="input-group">{{ obj.numero }}</div>
                              </div>
                            </div>
                            <div class="form-group row pt-2">
                              <div class="col-md-6">
                                <label><strong>Bairro</strong></label>
                                <div class="input-group">{{ obj.bairro }}</div>
                              </div>
                              <div class="col-md-6">
                                <label><strong>Cep</strong></label>
                                <div class="input-group">{{ formatCep(obj.cep) }}</div>
                              </div>
                            </div>
                            <div class="form-group row pt-2">
                              <div class="col-md-6">
                                <label><strong>Cidade</strong></label>
                                <div class="input-group">{{ obj.municipio }}</div>
                              </div>
                              <div class="col-md-6">
                                <label><strong>UF</strong></label>
                                <div class="input-group">{{ obj.uf }}</div>
                              </div>
                            </div>
                            <div class="form-group row pt-2">
                              <div class="col-md-12">
                                <label><strong>Endereço de correspondência</strong></label>
                                <div class="input-group">{{ obj.endereco }}</div>
                              </div>
                            </div>
                          </b-tab>
                        </b-tabs>
                      </div>
                      <div v-else>
                        <div class="form-group row pt-3">
                          <div class="col-md-12">
                            <label><strong>Endereço</strong></label>
                            <div class="input-group"></div>
                          </div>
                        </div>
                        <div class="form-group row pt-2">
                          <div class="col-md-6">
                            <label><strong>Complemento</strong></label>
                            <div class="input-group"></div>
                          </div>
                          <div class="col-md-6">
                            <label><strong>Número</strong></label>
                            <div class="input-group"></div>
                          </div>
                        </div>
                        <div class="form-group row pt-2">
                          <div class="col-md-12">
                            <label><strong>Bairro</strong></label>
                            <div class="input-group"></div>
                          </div>
                        </div>
                        <div class="form-group row pt-2">
                          <div class="col-md-6">
                            <label><strong>Cidade</strong></label>
                            <div class="input-group"></div>
                          </div>
                          <div class="col-md-6">
                            <label><strong>UF</strong></label>
                            <div class="input-group"></div>
                          </div>
                        </div>
                        <div class="form-group row pt-2">
                          <div class="col-md-12">
                            <label><strong>Endereço de correspondência</strong></label>
                            <div class="input-group"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block">
                    <div class="form-group row">
                      <div class="col-md-10 pb-2">
                        <h5><strong><i class="fas fa-phone-volume"></i> Contatos</strong></h5>
                      </div>
                      <div class="col-md-2">
                        <a v-if="!isBusyContato" href="javascript:void(0);" @click="toggleBusyContato"><i
                            class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover
                            :title="'Minimizar Dados'"></i></a>
                        <a v-else href="javascript:void(0);" @click="toggleBusyContato"><i class="fas fa-eye"
                            style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i></a>
                      </div>
                      <div class="table-responsive pt-2 pl-4 pr-4" v-if="phones && !isBusyContato">
                        <table class="table table-hover" style="border: 1px solid #dcdede;">
                          <thead class="thead-third" style="border: solid 1px #04a791;font-size: 12px;">
                            <tr>
                              <th class="text-center">TELEFONE</th>
                              <th class="text-center">TIPO</th>
                              <th class="text-center">AÇÕES</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(obj, index) in phones" :key="index">
                              <td class="text-center" style="padding: 8px;">
                                <a :href="`tel:${obj.telefone}`">{{ obj.telefone }}</a>
                              </td>
                              <td class="text-center" style="font-size: 11px;padding: 8px;">
                                {{ obj.tipoContato }}
                              </td>
                              <td @click="toastInfo" class="text-center" style="font-size: 14px; cursor: pointer; padding: 8px"><i :class="obj.tipoContato === 'CELULAR' ? 'fab fa-whatsapp' : 'fas fa-phone-alt'"></i></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block">
                    <div class="form-group row">
                      <div class="col-md-10 pb-2">
                        <h5><strong><i class="fas fa-users"></i> Relacionamento </strong></h5>
                      </div>
                      <div class="col-md-2">
                        <a v-if="!isBusyRelacionamento" href="javascript:void(0);" @click="toggleBusyRelacionamento"><i
                            class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover
                            :title="'Minimizar Dados'"></i></a>
                        <a v-else href="javascript:void(0);" @click="toggleBusyRelacionamento"><i class="fas fa-eye"
                            style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i></a>
                      </div>
                      <div class="table-responsive pt-2 pl-4 pr-4" v-if="phones && !isBusyRelacionamento">
                        <table class="table table-hover" style="border: 1px solid #dcdede;">
                          <thead class="thead-third" style="border: solid 1px #04a791;font-size: 12px;">
                            <tr>
                              <th class="text-center">DOCUMENTO</th>
                              <th class="text-center">NOME</th>
                              <th class="text-center">TIPO PESSOA</th>
                              <th class="text-center">DESCRIÇÃO</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr style="font-size: 11px;" v-for="(obj, index) in personRelations" :key="index">
                              <td class="text-center" style="font-size: 11px;padding: 8px;">
                                {{ obj.documentoPessoaRelacionada }}
                              </td>
                              <td class="text-center" style="font-size: 11px;padding: 8px;">
                                {{ obj.nomePessoaRelacionada }}
                              </td>
                              <td class="text-center" style="font-size: 11px;padding: 8px;">
                                {{ obj.tipopessoaRelacionada }}
                              </td>
                              <td class="text-center" style="font-size: 11px;padding: 8px;">
                                {{ obj.descricaoPessoaRelacionada }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block">
                    <div class="form-group row">
                      <div class="col-md-10 pb-2">
                        <h5><strong><i class="fas fa-users"></i> Grupo Econômico </strong></h5>
                      </div>
                      <div class="col-md-2">
                        <a v-if="!isBusyGrupoEconomico" href="javascript:void(0);" @click="toggleBusyGrupoEconomico"><i
                            class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover
                            :title="'Minimizar Dados'"></i></a>
                        <a v-else href="javascript:void(0);" @click="toggleBusyGrupoEconomico"><i class="fas fa-eye"
                            style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i></a>
                      </div>
                      <div class="table-responsive pt-2 pl-3 pr-3" v-show="!isBusyGrupoEconomico">
                        <table class="table table-hover" style="border: 1px solid #dcdede;" ref="tableGrid">
                          <thead class="thead-third" style="border: solid 1px #04a791;font-size: 12px;">
                            <tr>
                              <th class="text-center">NOME</th>
                              <th class="text-center">GRUPO ECONÔMICO</th>
                              <th class="text-center">CÓD. GRUPO ECONÔMICO</th>
                            </tr>
                          </thead>
                          <tbody v-if="!pessoaGrupoEconomicoList">
                            <tr>
                              <td colspan="3" class="text-center">Nenhum registro encontrado</td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr v-for="obj in this.pessoaGrupoEconomicoList" v-bind:key="obj.id">
                              <TableColumn :IsText="true" :status="1" :value="obj.nomeCliente"
                                @Edit="$emit('clickAssociate', obj.associadoId)" />
                              <TableColumn :IsText="true" :status="1" :value="obj.descricaoGrupoEconomico" />
                              <TableColumn :IsText="true" :status="1" :value="obj.codigoGrupoEconomico.toString()" />
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div v-if="objSelected && objSelected.pessoa.tipoPessoa == 'PF'" class="card">
                  <div class="card-block">
                    <div class="form-group row">
                      <div class="col-md-12 pb-2">
                        <h5><strong><i class="far fa-user"></i> Informações Pessoais</strong></h5>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-8">
                        <div class="input-group">
                          <strong>DOCUMENTO DE IDENTIFICAÇÃO:&nbsp;</strong>{{ objSelected ?
                            objSelected.pessoa.numeroDocumentoIdentidade : '' }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <div class="input-group">
                          <strong>UF: &nbsp;</strong>{{ objSelected ? objSelected.pessoa.siglaUFOrgaoExpeditor : '' }}
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="input-group">
                          <strong>Sexo:&nbsp;</strong>{{ objSelected && objSelected.pessoa.sexo == 'F' ? 'Feminino' :
                            'Masculino' }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <div class="input-group">
                          <strong>Orgão emissor:&nbsp;</strong>{{ objSelected ? objSelected.pessoa.descricaoOrgaoExpeditor
                            : '' }}
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="input-group">
                          <strong>Naturalidade:&nbsp;</strong>{{ objSelected ? objSelected.pessoa.naturalidade : '' }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <div class="input-group">
                          <strong>Estado civil:&nbsp;</strong>{{ objSelected ? objSelected.pessoa.estadoCivil : '' }}
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="input-group">
                          <strong>Escolaridade: &nbsp;</strong>{{ objSelected ? objSelected.pessoa.escolaridade : '' }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <h5><strong><i class="fa fa-university"></i> Informações de Contas</strong></h5>
                      </div>
                    </div>
                    <div v-for="contaCorrente in contaCorrenteList" :key="contaCorrente.id + 'ccorr'">
                      <strong>Conta Corrente: </strong>{{ contaCorrente ? contaCorrente.contaCorrente : '' }} <strong>-
                        Status:</strong> {{ contaCorrente ? contaCorrente.situacaoContaCorrente : '' }}
                    </div>
                    <div v-for="contaCapital in contaCapitalList" :key="contaCapital.id + 'ccap'">
                      <strong>Conta Capital: </strong>{{ contaCapital ? contaCapital.numContaCapital : '' }} <strong>-
                        Status:</strong> {{ contaCapital ? contaCapital.situacaoContaCapital : '' }}
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-block pb-5">
                    <div class="form-group row">
                      <div class="col-md-10">
                        <h5><strong><i class="far fa-user"></i> Informações do Associado</strong></h5>
                      </div>
                      <div class="col-md-2">
                        <a v-if="!isBusyInfosAssociado" href="javascript:void(0);" @click="toggleBusyInfosAssociado"><i
                            class="fas fa-eye-slash" style="font-size: 16px" v-b-tooltip.hover
                            :title="'Minimizar Dados'"></i></a>
                        <a v-else href="javascript:void(0);" @click="toggleBusyInfosAssociado"><i class="fas fa-eye"
                            style="font-size: 16px" v-b-tooltip.hover :title="'Mostrar Dados'"></i></a>
                      </div>
                    </div>
                    <div v-if="!isBusyInfosAssociado">
                      <div class="form-group row pt-2">
                        <div class="col-md-6">
                          <label><strong>Vínculo Empregatício</strong></label>
                          <div class="input-group">
                            {{ objSelected ? objSelected.vinculoEmpregaticio : '' }}
                          </div>
                        </div>
                        <div class="col-md-6 text-right">
                          <label><strong>Renda Bruta Mensal</strong></label>
                          <div class="text-right text-bold w100" style="font-size: 23px;">
                            {{ grossMonthlyIncome }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row pt-4">
                        <div class="col-md-6">
                          <label><strong>Descrição da Profissão</strong></label>
                          <div class="input-group">
                            {{ objSelected ? objSelected.descricaoProfissao : '' }}
                          </div>
                        </div>
                        <div class="col-md-6 text-right">
                          <label><strong>Tipo de Renda</strong></label>
                          <div class="text-right text-bold w100" style="font-size: 23px;">
                            {{ objSelected ? objSelected.tipoRenda : '' }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group row pt-1">
                        <div class="col-md-12">
                          <label><strong>Produtor Rural</strong></label>
                          <div class="input-group">
                            {{ objSelected ? isProdutorRural(objSelected.indicadorProdutorRural) : '' }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row pt-1">
                        <div class="col-md-12">
                          <label><strong>MEI</strong></label>
                          <div class="input-group">
                            {{ objSelected ? objSelected.mei : '' }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group row pt-3">
                        <div class="col-md-12">
                          <label><strong>Atividade Econômica</strong></label>
                          <div class="input-group">
                            {{ objSelected ? objSelected.atividadeEconomica : '' }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row pt-3 pb-3">
                        <div class="col-md-12 pb-5">
                          <label><strong>Descrição da Categoria</strong></label>
                          <div class="input-group"
                            v-for="descCat in objSelected ? objSelected.descricaoCategoria.filter(x => x != '-1') : []"
                            :key="descCat">
                            {{ descCat }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group row pt-1 pb-3">
                        <div class="col-md-12">
                          <label><strong>Bens Associado</strong></label>
                          <div class="input-group"></div>
                        </div>
                        <div class="table-responsive pt-2 pl-4 pr-4">
                          <table class="table table-hover" style="border: 1px solid #dcdede;">
                            <thead class="thead-third" style="border: solid 1px #04a791;font-size: 12px;">
                              <tr>
                                <th class="text-center">TIPO</th>
                                <th class="text-center">QUANTIDADE</th>
                                <th class="text-center">VALOR</th>
                              </tr>
                            </thead>
                            <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
                            <tbody v-if="!patrimony">
                              <tr>
                                <td colspan="3" class="text-center">Nenhum registro encontrado</td>
                              </tr>
                            </tbody>
                            <tbody v-else v-for="(obj, index) in patrimony" :key="index">
                              <tr v-if="parseInt(obj.qtdBemImovel)">
                                <td class="text-center" style="font-size: 11px;padding: 8px;">IMÓVEL</td>
                                <td class="text-center" style="font-size: 11px;padding: 8px;">{{ obj.qtdBemImovel }}</td>
                                <td class="text-center" style="font-size: 11px;padding: 8px;">{{
                                  onFormatMoney(obj.valorBemImovel) }}</td>
                              </tr>
                              <tr v-if="parseInt(obj.qtdBemMovel)">
                                <td class="text-center" style="font-size: 11px;padding: 8px;">MÓVEL</td>
                                <td class="text-center" style="font-size: 11px;padding: 8px;">{{ obj.qtdBemMovel }}</td>
                                <td class="text-center" style="font-size: 11px;padding: 8px;">{{
                                  onFormatMoney(obj.valorBemMovel) }}</td>
                              </tr>
                              <tr v-if="!parseInt(obj.qtdBemImovel) && !parseInt(obj.qtdBemMovel)">
                                <td colspan="3" class="text-center" style="font-size: 11px;padding: 8px;">Nenhum registro
                                  encontrado</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-12">
                          <label><strong>Observações</strong></label>
                          <div class="input-group">
                            <b-form-textarea v-model="form.observacao.value"
                              :placeholder="'Observações gerais do Associado'" :rows="form.observacao.rows"
                              :size="form.observacao.maxlength" :noResize="form.observacao.noResize">
                            </b-form-textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="form-group row pt-2 pb-2">
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover
                  :title="$lang.Common.Tooltip.ButtonBack" @click="onClose">
                  <i class="fas fa-undo"></i> <span class="d-md-down-none">{{ $lang.Common.Buttons.Back }}</span>
                </button>
                <button type="button" class="btn btn-third btn-sm" v-b-tooltip.hover
                  :title="$lang.Common.Tooltip.ButtonSave" @click="onUpdate">
                  <i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{ $lang.Common.Buttons.Save }}</span>
                </button>&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AssociateDetailsTabs ref="AssociateDetailsTabs"/>
  </div>
</template>
<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import RestrictionAlertVue from '@/components/UI/restrictionAlert/restrictionAlert'
import AssociateDetailsTabs from '@/views/private/associate/components/associatedetailsTabs.vue'

import ContaCorrente from '@/shared/http/repositories/business/averagebalancecco.js'
import ContaCapital from '@/shared/http/repositories/business/capitalaccount.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import PatrimonyRepository from '@/shared/http/repositories/business/patrimony.js'
import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import FuncionarioRepository from '@/shared/http/repositories/configurations/employee.js'
import EconomicGroupRepository from '@/shared/http/repositories/business/economicgroup.js'
import PARepository from '@/shared/http/repositories/configurations/pa'

import TabPessoasGrupoEconomico from '@/views/private/associate/tabs/pessoasgrupoeconomico.vue'

const formDetail = {
  observacao: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '4',
    noResize: true
  },
  clusterizacaoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  gerenteRelacionamento: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  prinome: {
    value: null,
    required: false,
    state: null
  },
  pendencias: {
    ajuizado: {
      value: null,
      required: false,
      state: null
    },
    notificado: {
      value: null,
      required: false,
      state: null
    },
    cobranca: {
      value: null,
      required: false,
      state: null
    },
    impeditivaAbsoluta: {
      value: null,
      required: false,
      state: null
    }
  }
}

export default {
  name: 'AssociateDetails',
  mixins: [ActionsForm],
  data () {
    return {
      form: formDetail,
      objSelected: null,
      screenW: screen.width,
      patrimony: null,
      contaCorrenteList: [],
      contaCapitalList: [],
      paGerenteRelacionamento: [],
      pessoaGrupoEconomicoList: [],
      paGerenteSisbr: [],
      hasRestrictions: false,
      isBusyInfosAssociado: true,
      isBusyGrupoEconomico: true,
      isBusyContato: true,
      isBusyLogradouro: true,
      isBusyRelacionamento: true
    }
  },
  components: {
    TabPessoasGrupoEconomico,
    RestrictionAlertVue,
    AssociateDetailsTabs
  },
  created () {
    this.onLoadAssociado(this.associateId)
    this.onLoadAllCluster()
    this.onLoadAllFuncionarios()
  },
  watch: {
    'objSelected': function () {
      this.form.clusterizacaoId.value = null
      this.form.observacao.value = ''
      this.paGerenteRelacionamento = []
      this.paGerenteSisbr = []

      if (this.objSelected) {
        this.onLoadAssociado(this.objSelected.id)
        if (this.objSelected.gerenteSisBR) {
          this.getPaGerenteSisbr(this.objSelected.gerenteSisBR.paId)
        }
      }
    }
  },
  computed: {
    grossMonthlyIncome () {
      let result = 'R$ 0,00'
      if (this.objSelected) {
        result = Tools.formatMoneyBR(this.objSelected.rendaBrutaMensal)
      }
      return result
    },
    address () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.endereco) {
        result = this.objSelected.pessoa.endereco
      }
      return result
    },
    phones () {
      let result = null
      if (this.objSelected && this.objSelected.pessoa.telefone) {
        result = this.objSelected.pessoa.telefone
      }
      return result
    },
    personRelations () {
      let result = null
      if (this.objSelected && this.objSelected.pessoaRelacionada) {
        result = this.objSelected.pessoaRelacionada
      }
      return result
    },
    initialName: function () {
      let result = ''
      if (this.objSelected && this.objSelected.nome) {
        var names = this.objSelected.nome.split(' ')
        if (names && names.length > 1) {
          result = names[0].substring(0, 1) + names[names.length - 1].substring(0, 1)
        } else if (names && names.length > 0) {
          result = names[0].substring(0, 1)
        }
      }
      return result
    },
    personTypeByDocument: function () {
      let result = 'PF'
      if (this.objSelected && this.objSelected.document) {
        let doc = this.objSelected.document.replace('.', '')
        doc = doc.replace('.', '')
        doc = doc.replace('-', '')
        doc = doc.replace('/', '')

        if (doc.length > 11) {
          result = 'PJ'
        }
      }
      return result
    },
    associateId () {
      return this.$route.params.associateId
    },
    backUrl: function () {
      return this.$route.params.backUrl
    }
  },
  methods: {
    onClose () {
      if (this.backUrl) {
        this.$router.push({ name: this.backUrl })
      } else {
        this.$router.push({ name: 'CRM' })
      }
    },
    onLoad () { },
    onCallDependences (document) {
      this.onLoadAllPatrimony(document)
      this.onLoadContaCorrente(document)
      this.onLoadContaCapital(document)
      this.onLoadTabPessoasEconomicGroup(document)
    },
    onLoadTabPessoasEconomicGroup (document) {
      loading.push()
      this.document = document
      EconomicGroupRepository.SearchPeopleIn(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.pessoaGrupoEconomicoList = response.data.content
        })
        .catch((err) => {
          this.onException(err)
        })
      loading.close()
    },
    onLoadAssociado (id) {
      loading.push()
      this.form.clusterizacaoId.value = null
      this.form.observacao.value = ''
      this.form.gerenteRelacionamento.value = null
      this.form.prinome.value = null
      this.form.pendencias.notificado.value = false
      this.form.pendencias.ajuizado.value = false
      this.form.pendencias.cobranca.value = false
      this.form.pendencias.impeditivaAbsoluta.value = false
      AssociateRepository.GetById(id)
        .then((response) => {
          var obj = response.data
          this.checkPendencias(obj)

          if (!this.objSelected) {
            this.objSelected = obj
            this.$refs.AssociateDetailsTabs.objSelected = obj
            this.$refs.AssociateDetailsTabs.onCallDependences(obj.pessoa.document)
            this.onCallDependences(obj.pessoa.document)
          }

          this.form.clusterizacaoId.value = obj.clusterizacaoDTO ? obj.clusterizacaoDTO.id : null
          this.form.observacao.value = obj.observacao ? obj.observacao : null
          this.form.prinome.value = obj.pessoa.prinome ? obj.pessoa.prinome : null
          this.form.pendencias.notificado.value = obj.pendencias ? obj.pendencias.notificado : false
          this.form.pendencias.ajuizado.value = obj.pendencias ? obj.pendencias.ajuizado : false
          this.form.pendencias.cobranca.value = obj.pendencias ? obj.pendencias.cobranca : false
          this.form.pendencias.impeditivaAbsoluta.value = obj.pendencias ? obj.pendencias.impeditivaAbsoluta : false
          if (obj.gerenteRelacionamento) {
            this.form.gerenteRelacionamento.value = {
              'gerenteRelacionamentoId': obj.gerenteRelacionamento.id,
              'paId': obj.gerenteRelacionamento.paId,
              'nome': obj.gerenteRelacionamento.pessoa.nome
            }
          }
          loading.close()
          loading.close()
          loading.close()
          loading.close()
          loading.close()
          loading.close()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    onLoadAllPatrimony (document) {
      loading.push()
      this.patrimony = null
      PatrimonyRepository.Search(document, 50, 0)
        .then((response) => {
          if (response.data.content.length > 0) {
            this.patrimony = response.data.content
          }
          loading.close()
        })
        .catch(this.onException)
    },
    onLoadAllCluster () {
      loading.push()
      ClusterRepository.GetAll()
        .then((response) => {
          this.form.clusterizacaoId.options = this.onResultDropdown(response, null, f => f.descricao)
        })
        .catch(this.onException)
    },
    onLoadAllFuncionarios () {
      loading.push()
      FuncionarioRepository.GetAll()
        .then((response) => {
          this.form.gerenteRelacionamento.options = this.setDropdownGerentesRelacionamentoOptions(response)
        })
        .catch(this.onException)
    },
    onLoadContaCorrente (document) {
      ContaCorrente.Search(document)
        .then((response) => {
          let setOfContas = new Set()
          this.contaCorrenteList = response.data.content.filter((x) => !setOfContas.has(x.contaCorrente) && (setOfContas.add(x.contaCorrente) || true))
        })
        .catch(this.onException)
    },
    onLoadContaCapital (document) {
      ContaCapital.Search(document, 500, 0)
        .then((response) => {
          let setOfContas = new Set()
          this.contaCapitalList = response.data.content.filter((x) => !setOfContas.has(x.numContaCapital) && (setOfContas.add(x.numContaCapital) || true))
        })
        .catch(this.onException)
    },
    setDropdownGerentesRelacionamentoOptions (response) {
      let result = []
      let data = response.data.content
      for (let i in data) {
        result.push({ 'gerenteRelacionamentoId': data[i].id, 'paId': data[i].paId, 'nome': data[i].pessoa.nome })
      }

      return result
    },
    onFormatMoney (value) {
      let result = 'R$ 0,00'
      if (value) {
        result = Tools.formatMoneyBR(value)
      }
      return result
    },
    onCopyName () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.nome)
      }
    },
    onCopyDocument () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.pessoa.document)
      }
    },
    onCopyNumSisbr () {
      if (this.objSelected) {
        this.onCopy(this.objSelected.numSisbr)
      }
    },
    onCopy (value) {
      if (value) {
        var obj = this.$refs.myCopy
        obj.value = value
        obj.setAttribute('type', 'text')
        obj.select()
        document.execCommand('copy')
        toast.success(this.$lang.Common.Alerts.CopySuccess)
        obj.setAttribute('type', 'hidden')
      }
    },
    onUpdate () {
      const dataUpdate = {
        'id': this.objSelected.id,
        'document': this.objSelected.pessoa.document,
        'numSisbr': this.objSelected.numSisbr,
        'gerenteSisBRId': this.objSelected.gerenteSisBR ? this.objSelected.gerenteSisBR.id : 0,
        'gerenteRelacionamentoId': this.form.gerenteRelacionamento.value ? this.form.gerenteRelacionamento.value.gerenteRelacionamentoId : 0,
        'clusterizacaoId': this.form.clusterizacaoId.value || 0,
        'prinome': this.form.prinome.value || null,
        'enderecosId': [],
        'telefonesId': [],
        'tipoPessoa': this.objSelected.pessoa.tipoPessoa,
        'nomeAssociado': this.objSelected.pessoa.nome,
        'inicioRelacionamento': this.objSelected.inicioRelacionamento,
        'ultimaRenovacao': this.objSelected.ultimaRenovacao,
        'email': this.objSelected.pessoa.email,
        'telefoneCelular': '',
        'telefoneComercial': '',
        'telefoneResidencial': '',
        'rendaBrutaMensal': this.objSelected.rendaBrutaMensal,
        'tipoRenda': this.objSelected.tipoRenda,
        'vinculoEmpregaticio': this.objSelected.vinculoEmpregaticio,
        'descricaoProfissao': this.objSelected.descricaoProfissao,
        'atividadeEconomica': this.objSelected.atividadeEconomica,
        'descricaoCategoria': this.objSelected.descricaoCategoria,
        'dataNascimento': this.objSelected.pessoa.dataNascimento,
        'observacao': this.form.observacao.value,
        'pendencias': {},
        'notificado': this.form.pendencias.notificado.value,
        'ajuizado': this.form.pendencias.ajuizado.value,
        'cobranca': this.form.pendencias.cobranca.value,
        'impeditivaAbsoluta': this.form.pendencias.impeditivaAbsoluta.value
      }
      dataUpdate.enderecosId = []
      this.objSelected.pessoa.endereco.forEach(element => {
        dataUpdate.enderecosId.push(element.id)
      })

      dataUpdate.telefonesId = []
      this.objSelected.pessoa.telefone.forEach(element => {
        dataUpdate.telefonesId.push(element.id)
      })

      dataUpdate.pendencias.notificado = this.form.pendencias.notificado.value
      dataUpdate.pendencias.ajuizado = this.form.pendencias.ajuizado.value
      dataUpdate.pendencias.cobranca = this.form.pendencias.cobranca.value
      dataUpdate.pendencias.impeditivaAbsoluta = this.form.pendencias.impeditivaAbsoluta.value

      loading.push()
      AssociateRepository.Update(dataUpdate.id, dataUpdate)

        .then(() => {
          loading.close()
          this.checkPendencias(dataUpdate)
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    getPaGerenteSisbr (paIdList) {
      this.paGerenteSisbr = []
      for (let i in paIdList) {
        PARepository.GetById(paIdList[i])
          .then((res) => {
            this.paGerenteSisbr.push(res.data)
          })
          .catch(this.onException)
      }
    },
    checkPendencias (person) {
      if (!person.pendencias) {
        this.hasRestrictions = false
        return
      }
      if (Object.values(person.pendencias).some(item => item === true)) {
        this.hasRestrictions = true
      } else {
        this.hasRestrictions = false
      }
    },
    formatCep (cep) {
      var re = /^([\d]{5})([\d]{3})/
      if (re.test(cep)) {
        // eslint-disable-next-line no-useless-escape
        return cep.replace(re, '\$1-\$2')
      } else {
        return 'CEP inválido!'
      }
    },
    getInitialName (value) {
      return Tools.getInitialsOfName(value)
    },
    getTipoPessoa (document) {
      return Tools.checkDocumentType(document)
    },
    isProdutorRural (value) {
      let result = Number.parseInt(value)

      return result === 1 ? 'Sim' : 'Não'
    },
    formatDateTimeForms (obj) {
      return obj.split('T')[0].split('-').reverse().join('/')
    },
    toggleBusyInfosAssociado () {
      this.isBusyInfosAssociado = !this.isBusyInfosAssociado
    },
    toggleBusyGrupoEconomico () {
      this.isBusyGrupoEconomico = !this.isBusyGrupoEconomico
    },
    toggleBusyRelacionamento () {
      this.isBusyRelacionamento = !this.isBusyRelacionamento
    },
    toggleBusyLogradouro () {
      this.isBusyLogradouro = !this.isBusyLogradouro
    },
    toggleBusyContato () {
      this.isBusyContato = !this.isBusyContato
    },
    toastInfo () {
      toast.info('Esta funcionalidade ainda não está disponível no seu nxCoop.')
    }
  }
}
</script>
<style lang="scss">
.notification__modal__header {
  background-color: #FFA500 !important;
  background-color: #FF0000 !important;
}

#notificationModal {
  p {
    font-size: 1rem;
  }

  .btn {
    color: #FFF;
    background-color: #04A791 !important;
  }
}
</style>

<style scoped>
td {
  padding: 0 15px;
}

ul {
  list-style: none outside none;
  margin: 0;
  padding: 0;
}

li {
  float: left;
  margin: 0 30px;
}

.title-tab-configuration {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #5d626c;
}

.title-tab-configuration a {
  text-decoration: underline;
  color: #04a791;
}

.close-card {
  text-align: right;
  display: block;
  right: 10px;
  position: absolute;
  top: 10px;
  z-index: 999;
}

card-header .nav.nav-tabs .nav-link,
.card-header .nav.nav-tabs .navbar .dropdown-toggle,
.navbar .card-header .nav.nav-tabs .dropdown-toggle {
  padding: .75rem .625rem;
  color: #04a791;
  border-top: 0;
}

.accordion>.card>.card-header {
  border-radius: 0;
  margin-bottom: 0px;
}

.p-1 {
  padding: 0.85rem !important;
}

@media (min-width: 576px) {
  .w-sm-50 {
    width: 75% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/associatedetails.vue